/**
 * @generated SignedSource<<2c2650a2c6076ca60b0c8a3e6cad830b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Timer_viewer$data = {
  readonly timerStartDate: string | null;
  readonly timerEndDate: string | null;
  readonly timerTask: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "Timer_viewer";
};
export type Timer_viewer$key = {
  readonly " $data"?: Timer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Timer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Timer_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerEndDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "78b1b516352c9a99a45b8e0b76b62369";

export default node;
